import { MatchRepository } from "../repositories/MatchRepository";

export class CreateOrderPaypal {
	constructor(private repository: MatchRepository) {}
	execute(data: CreateOrderPaypalParams): Promise<string> {
		return this.repository.createOrderPaypal(data.product_id, data.quantity);
	}
}

export class CreateOrderPaypalParams {
	constructor(public product_id: string, public quantity: number) {}
}
